export default [

    // *--------- SHED --------------------------------*
    {
        path: '/railway-structure/shed/list',
        name: 'railway_structure-shed-list',
        component: () => import('@/views/apps/railway_structure/shed/views/List.vue'),
        meta: {
            resource: 'shed',
            action: 'read',
            pageTitle: ' Навесы',
            breadcrumb: [
                {
                  text: 'Структура ЖД',
                    active: true,
                },
                {
                  text: 'Навесы',
                  active: true,
                },
            ],
        },
    },
    {
        path: '/railway-structure/shed/view/:id',
        name: 'railway_structure-shed-view',
        component: () => import('@/views/apps/railway_structure/shed/views/Details.vue'),
        meta: {
            resource: 'railway',
            action: 'read',
            pageTitle: 'Навесы',
            breadcrumb: [
                {
                    text: 'Структура ЖД',
                    active: true,
                },
                {
                    text: 'Навесы',
                    to: {
                        name: 'railway_structure-shed-list'
                    }
                },
                {
                    text: 'Детали',
                    active: true
                },
            ],
        },
    },
]
